import type { TileSize } from '@/types/TileSize';

/**
 * Determine if the car tile needs to be shown in a featured state, as some
 * sizes do not actually support this, and some *only* support this.
 */
export function isFeaturedCarTile(size: TileSize, isFeatured: boolean) {
  switch (size) {
    case 'small':
    case 'medium':
      return false;
    case 'xlarge':
      return true;
    default:
      return isFeatured;
  }
}
